import * as ApplicationInsightsInstance from 'applicationinsights';
import { Validation } from './utils/Validation';
import { Contracts } from 'applicationinsights';
import { BaseEvent, BpmValidation, ComponentType, CorrelationConstants, ExtensionsConfig, ItEventType,
     ItTelemetryConfiguration, SerializationHelper, BusinessProcessEvent, FeatureUsageEvent, SystemEvent, 
     EnvironmentValues } from './datacontracts';

export  { BaseEvent, BpmValidation, ComponentType, CorrelationConstants, ExtensionsConfig, ItEventType, 
    ItTelemetryConfiguration, SerializationHelper, BusinessProcessEvent, FeatureUsageEvent, SystemEvent, EnvironmentValues};

const version = process.env.npm_package_version;

export class UTPTelemetry{
    protected telemetryInstance: ApplicationInsightsInstance.TelemetryClient;
    constructor(instrumentationKey: string, environment: EnvironmentValues){        
        if(Validation.InstrumentationKey(instrumentationKey)){
            this.telemetryInstance = new ApplicationInsightsInstance.TelemetryClient(instrumentationKey);
            this.telemetryInstance.commonProperties = environment.getTelemetryObject(instrumentationKey, "UTP-Node-JS-SDK-"+version);
            console.log(version);
        }
        else{
            console.error("Validation check failed, please check if you have given a valid Instrumentation Key");
        }
    }

    public TrackTrace(traceMessage: string, severity: Contracts.SeverityLevel = null){
        if(traceMessage && traceMessage.length > 0){
            this.telemetryInstance.trackTrace({message: traceMessage, severity: severity});
            return true;
        }                
        console.log("Trace message cannot be empty ");
        return false;
    }

    public TrackEvent(eventName: string){
        if(eventName && eventName.length > 0){
            this.telemetryInstance.trackEvent({name: eventName});
            return true;
        }
        console.log("Event name cannot be empty ");
        return false;
    }

    public TrackMetric(metricName: string, metricValue: number, metricCount: number, minValue?: number, maxValue?: number, stdDev?: number){
        if(metricName && metricName.length > 0){
            this.telemetryInstance.trackMetric({name:metricName, value: metricValue, count: metricCount, 
                min: minValue, max: maxValue, stdDev: stdDev});
            return true;
        }
        console.log("Metric name cannot be empty ");
        return false;
    }

    public TrackRequest(requestName: string, requestUrl: string, requestDuration: number, requestResultCode: string | number, isRequestSuccess: boolean, requestSource?: string){
        if(requestName && requestName.length > 0){
            this.telemetryInstance.trackRequest({name: requestName, url: requestUrl, duration: requestDuration, 
                resultCode: requestResultCode,success: isRequestSuccess, source: requestSource });
            return true;
        }
        console.log("Request name cannot be empty ");
        return false;
    }

    public TrackDependency(dependencyName: string, dependencyTypeName: string, dependencyData: string, dependencyDuration: number, dependencyResultCode: number, isSuccess: boolean, dependencyTarget?: string){
        if(dependencyName && dependencyName.length > 0){
            this.telemetryInstance.trackDependency({name: dependencyName, dependencyTypeName: dependencyTypeName, data: dependencyData, 
                duration: dependencyDuration, resultCode: dependencyResultCode, success: isSuccess, target: dependencyTarget});
            return true;
        }
        console.log("Dependency name cannot be empty ");
        return false;
    }

    public TrackException(exceptionMessage: string, exeptionMesaurements?: {[key: string]: number}){
        if(exceptionMessage && exceptionMessage.length > 0){
            this.telemetryInstance.trackException({exception: new Error(exceptionMessage), measurements: exeptionMesaurements});
            return true;
        }
        console.log("Exception name cannot be empty ");
        return false;
    }

    public TrackFeatureUsageEvent(featureUsageEventData: FeatureUsageEvent){
        if(featureUsageEventData.IsValidEvent()){
            var telemetryObject = featureUsageEventData.getTelemtryObject();
            this.telemetryInstance.trackEvent({name: featureUsageEventData.EventName, properties: telemetryObject});
            return true;
        } 
        else{
            console.log("Please give a valid event name");
            return false;
        }       
    }

    public TrackBusinessProcessEvent(bussinessProcessEventData: BusinessProcessEvent){
        if(bussinessProcessEventData.IsValidEvent()){
            var telemetryObject = bussinessProcessEventData.getTelemetryObject();
            this.telemetryInstance.trackEvent({name: bussinessProcessEventData.EventName, properties: telemetryObject});
            return true;
        }  
        else{
            console.log("Mandatory fields appAction, businessProcessName, receiverId, senderId, eventOccurenceTime");
            return false;
        }      
    }

    public TrackSystemEvent(systemEventData: SystemEvent){
        if(systemEventData.IsValidEvent()){
            var telemetryObject = systemEventData.getTelemetryObject();
            this.telemetryInstance.trackEvent({name: systemEventData.EventName, properties: telemetryObject});
            return true;
        }
        else{
            console.log("Please give a valid event name");
            return false;
        }    
    }
}
